import { useEffect, useState, useCallback } from 'react';
import Pagination from '@src/common/Pagination';
import { useNavigate } from 'react-router-dom';
import { COUNTRY_CODE, DEFAULT_PAGE_NO, DEFAULT_PAGINATION_COUNT } from '@src/config/constant';
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import { AGENT_COMMISSION_STATUS, ROLE } from "@src/config/id/constant";
import * as HELPER from "@src/config/helper";
import ProfitChangeModal from '@pages/ProfitChangeModal';
import secureStorage from '@src/config/encrypt';
import { useLanguage } from "@src/context/LanguageContext";
import FullPageLoader from '@common/FullPageLoader';

function AgentCommissionChangeList(props: any) {
    let { insuranceList, paginationData, selectedFilters, setTrigger} = props;
    const [searchParams] = useSearchParams();
    const isCountryId = COUNTRY_CODE === 'id' ? true : false;
    const {translations} = useLanguage();
    const page = DEFAULT_PAGE_NO;
    const [insuranceListData, setInsuranceListData] = useState<any>([]);
    const [selectedLead, setSelectedLead] = useState<any>(null);
    const [showAgentPointPopup, setShowAgentPointPopup] = useState(false);
    const [showPointsApprovalPopup, setShowPointsApprovalPopup] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);
    let auth = secureStorage.getItem("authAgentUserInfo");
    const roleId = auth?.user_data?.role_id;


    useEffect(() => {
        setInsuranceListData(insuranceList);
    }, [insuranceList]);


    const handleRequestData = (params: any) => {
        let apiParams = {
            ...selectedFilters,
            page_number: params.page_no
        }
        props.getInsuranceListing(apiParams)

    }

    const openLeadModals = (lead: any) => {
        setSelectedLead(lead);
        if(roleId === ROLE.BM){
        setShowAgentPointPopup(true);
        }else if(roleId === ROLE.VP || roleId === ROLE.SH){
        setShowPointsApprovalPopup(true);
        }
    };


    const [sharedOnSort, setSharedOnSort] = useState<"asc" | "desc">("desc");

    const handleSharedOnSort = () => { setSharedOnSort(prev => (prev === "asc" ? "desc" : "asc")); };

    return (
        <>
        <FullPageLoader show={loading} />
            <div className={(selectedFilters?.type && selectedFilters?.type === "claim") ? `lead-list-data-table data-table managepanel-tab claim-list-type wap-table` : `lead-list-data-table data-table managepanel-tab wap-table`} >
                <table className=''>
                    <thead>
                        <tr>
                            <th>{translations?.AGENT_COMMISSION?.AGENT_NAME} </th>
                            <th>{translations?.COMMISSION?.INS_ID} </th>
                            <th> {translations?.AGENT_COMMISSION?.KTP_ID}</th>
                            <th> {translations?.AGENT_COMMISSION?.SHARED_ON}  </th>
                            <th>{translations?.AGENT_COMMISSION?.AGENT_NEW_PT} </th>

                            {(selectedFilters.status_type == AGENT_COMMISSION_STATUS.rejected) &&
                                <th> {translations?.AGENT_COMMISSION?.REVISED_PT} </th>
                            }

                            <th> {translations?.AGENT_COMMISSION?.PT_VAL} </th>

                            {(selectedFilters.status_type == AGENT_COMMISSION_STATUS.approved) &&
                                <th> {translations?.AGENT_COMMISSION?.STATUS} </th>
                            }

                            {(selectedFilters.status_type == AGENT_COMMISSION_STATUS.rejected) &&
                                <th> {translations?.AGENT_COMMISSION?.REVISED_PT_VAL} </th>
                            }

                            <th> {translations?.AGENT_COMMISSION?.ACTION} </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            insuranceListData?.length ?
                                insuranceListData?.map((lead: any, key: number) =>
                                    <tr key={key}>
                                        <td>
                                            <div className="table-txt-data">
                                                <span title={lead.agent_name}>{lead.agent_name || ""}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="table-txt-data">
                                                <span title={lead.lead_code}>{lead.lead_code || ""}</span>
                                            </div>
                                        </td>

                                        <td>
                                            <div className="table-txt-data">
                                                <span title={lead.ktp_id}>{lead.ktp_id || ""}</span>
                                            </div>
                                        </td>

                                        <td >
                                            <div className="table-txt-data">
                                                <span title="created_date"> {lead.created_at ? new Date(lead.created_at).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : ""}</span>
                                            </div>
                                        </td>

                                        {/* agent new point */}
                                        <td>
                                            <div className="table-txt-data">
                                                <span title={lead.agent_new_point}>{`${lead.agent_new_point} %` || ""} </span>
                                            </div>
                                        </td>

                                        {/* revised point */}

                                        {(selectedFilters.status_type == AGENT_COMMISSION_STATUS.rejected) &&
                                            <td>
                                                <div className="table-txt-data">
                                                    <span title={lead.agent_new_point}>{`${lead.agent_new_point}` || ""} </span>
                                                </div>
                                            </td>
                                        }

                                        {/* point value */}
                                        <td >
                                            <div className="table-txt-data">
                                                <span title={lead.agent_new_point_value}>{HELPER.addCurrencyFormatting(lead.agent_new_point_value || "")}</span>
                                            </div>
                                        </td>

                                        {/* status */}
                                        {(selectedFilters.status_type == AGENT_COMMISSION_STATUS.approved) &&
                                            <td >
                                                <div className="table-txt-data">
                                                    <span title={lead.status_name} className={lead.status_name ? "status-pill" : ""}>{lead.status_name || "-"}</span>
                                                </div>
                                            </td>
                                        }

                                        {/* revised point value */}

                                        {(selectedFilters.status_type == AGENT_COMMISSION_STATUS.rejected) &&
                                            <td >
                                                <div className="table-txt-data">
                                                    <span title={lead.agent_new_point_value} >{HELPER.addCurrencyFormatting(lead.agent_new_point_value || "")}</span>
                                                </div>
                                            </td>
                                        }

                                        {/* action */}
                                        <td >
                                            <div className="table-txt-data">
                                                <button className="btn-line btn-width-auto m-sm-r" onClick={() => openLeadModals(lead)}>
                                                    <i className="m-xs-r"></i> {translations?.AGENT_COMMISSION?.VIEW_DETAILS}</button>
                                            </div>
                                        </td>

                                    </tr>
                                )
                                :
                                <tr><td  colSpan={document.querySelectorAll("thead th").length} style={{ textAlign: 'center' }}> {translations?.AGENT_COMMISSION?.NO_DATA}</td></tr>

                        }
                    </tbody>
                </table>

                {(paginationData && paginationData['total'] > DEFAULT_PAGINATION_COUNT) && <Pagination paginateData={{
                    page,
                    loading: false,
                    totalLengthWithoutPagination: paginationData['total'],
                    paginationData,
                    filteredData: selectedFilters
                }}
                    sendRequestDataToParent={handleRequestData} />}
            </div >


            {
                isCountryId && showAgentPointPopup && (
                    <ProfitChangeModal
                        type="summary"
                        show={showAgentPointPopup}
                        handleClose={() => setShowAgentPointPopup(false)}
                        leadDetail={selectedLead}
                        statusType = {selectedFilters.status_type}
                        setTrigger={setTrigger}
                        setLoading = {setLoading}
                    />
                )}

             {
                isCountryId && showPointsApprovalPopup && (
                    <ProfitChangeModal
                        type="pointsApproval"
                        show={showPointsApprovalPopup}
                        handleClose={() => setShowPointsApprovalPopup(false)}
                        leadDetail={selectedLead}
                        statusType = {selectedFilters.status_type}
                        setTrigger={setTrigger}
                        callFrom = "AgentComChangeList"
                        setLoading = {setLoading}
                    />
                )}   

        </>
    )
}

export default AgentCommissionChangeList